import { useMemo } from "react";
import { WeatherStation } from "../../../api/rtk/weatherStations/slices/weatherStationsApiSlice";
import { getGeoJSONFeaturesVectorLayer } from "../../../widgets/map/mapFeatures/layers";
import { getWeatherStationStyle } from "../../../widgets/map/mapFeatures/styles/weatherStations/weatherStationsStyles";

export function useWeatherStationsMapLayer(weatherStations?: [WeatherStation]) {
    const weatherStationsGeoJSON = useMemo(() => {
        if (weatherStations) {
            return {
                type: "FeatureCollection",
                features: weatherStations?.map((weatherStation) => {
                    const { id, latitude, longitude, name } = weatherStation ?? {}
                    return {
                        type: "Feature",
                        geometry: {
                            type: "Point",
                            coordinates: [longitude, latitude]
                        },
                        properties: { id, name }
                    }
                })
            }
        }
    }, [weatherStations])

    const weatherStationsLayer = useMemo(() => {
        if (weatherStationsGeoJSON) return getGeoJSONFeaturesVectorLayer(weatherStationsGeoJSON, "EPSG:3857", getWeatherStationStyle)
    }, [weatherStationsGeoJSON]);
    weatherStationsLayer?.set('id', 'WeatherStationsVec');

    return weatherStationsLayer
}